<template>
  <div class="loading-frames">
    <div class="loading-frames__spinner" />
    <div class="loading-frames__content">{{ $t('Loading animation') }} - {{ count }}</div>
  </div>
</template>

<script>
export default {
  name: "LoadingFrames",
  props: {
    count: {
      type: String,
      default: '0/72'
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.loading-frames {
    height: 40px;
    width: 40px;
    position: absolute;
    top: 15px;
    right: 40px;
    font-size: .85rem;
    color: $accent-text;
    padding: .5rem;
    background-color: white;
    border-radius: $border-radius;
    align-items: center;
    justify-content: center;
    display: flex;
    z-index: 2;

    @media screen and (min-width: 768px) {
        width: auto;
    }

    @media screen and (min-width: 901px) {
        right: 138px;
        top: unset;
        bottom: 40px;
    }

    @media screen and (orientation: portrait) {
        top: 40px;
    }


    &__content {
        line-height: 100%;
        display: none;

        @media screen and (min-width: 768px) {
          display: block;
        }
    }

    &__spinner {
        width: 1.25rem;
        height: 1.25rem;
        position: relative;

        @media screen and (min-width: 768px) {
            margin-right: .5rem;
        }

        &:before {
            content: '';
            box-sizing: border-box;
            position: absolute;
            top: 50%;
            left: 50%;
            width: 100%;
            height: 100%;
            margin-top: -10px;
            margin-left: -10px;
            border-radius: 50%;
            border: 2px solid #ccc;
            border-bottom-color: $accent-color;
            animation: spinner 1s linear infinite;
        }
    }

    @keyframes spinner {
        to {
            transform: rotate(360deg);
        }
    }
}
</style>
